import { createContext } from "react";

export type SideBarContextType = {
  expanded: boolean;
};

export const SideBarContext = createContext<SideBarContextType>({
  expanded: false,
});
